/** Resolve active season from env flags. Priority: summer → autumn → spring → winter. */
export const SEASON_ORDER = ['summer', 'autumn', 'spring', 'winter'];

export const SEASON_ENV_KEYS = {
  summer: 'SUMMER',
  autumn: 'AUTUMN',
  spring: 'SPRING',
  winter: 'WINTER',
};

export function flagOn(raw) {
  if (raw === undefined || raw === null) return null;
  const v = String(raw).trim();
  if (v === '') return null;
  return v === '1' || v.toLowerCase() === 'true';
}

/** @returns {'summer'|'autumn'|'spring'|'winter'|null} */
export function resolveSeasonFromFlags(flags) {
  // flags: { summer: true|false|null, ... }  null = unset
  let sawExplicit = false;
  for (const id of SEASON_ORDER) {
    const v = flags[id];
    if (v === null || v === undefined) continue;
    sawExplicit = true;
    if (v) return id;
  }
  return sawExplicit ? null : null;
}

export function resolveSeasonFromProcessEnv(getEnv = (k) => process.env[k]) {
  const flags = {};
  for (const id of SEASON_ORDER) {
    flags[id] = flagOn(getEnv(SEASON_ENV_KEYS[id]));
  }
  // Also allow SEASON=summer|autumn|spring|winter
  const named = String(getEnv('SEASON') || '').trim().toLowerCase();
  if (SEASON_ORDER.includes(named)) return named;

  return resolveSeasonFromFlags(flags);
}

export function resolveSeasonFromFrontendEnv() {
  const named = String(process.env.REACT_APP_SEASON || '').trim().toLowerCase();
  if (SEASON_ORDER.includes(named)) return named;

  const flags = {
    summer: flagOn(process.env.REACT_APP_SUMMER),
    autumn: flagOn(process.env.REACT_APP_AUTUMN),
    spring: flagOn(process.env.REACT_APP_SPRING),
    winter: flagOn(process.env.REACT_APP_WINTER),
  };
  return resolveSeasonFromFlags(flags);
}

export const ANT_SEASON_TOKENS = {
  summer: {
    colorPrimary: '#f0a202',
    borderRadius: 2,
    colorBgContainer: '#1a2228',
    colorLink: '#f0a202',
  },
  autumn: {
    colorPrimary: '#e07a3d',
    borderRadius: 2,
    colorBgContainer: '#221c18',
    colorLink: '#e07a3d',
  },
  spring: {
    colorPrimary: '#5cb88a',
    borderRadius: 2,
    colorBgContainer: '#1a2420',
    colorLink: '#7ec8a3',
  },
  winter: {
    colorPrimary: '#d4af37',
    borderRadius: 2,
    colorBgContainer: '#1c1f28',
    colorLink: '#d4af37',
  },
  default: {
    colorPrimary: '#00b96b',
    borderRadius: 2,
    colorBgContainer: '#f6ffed',
  },
};
